import { render, staticRenderFns } from "./Provid.vue?vue&type=template&id=2c07b6fa&scoped=true"
import script from "./Provid.vue?vue&type=script&lang=js"
export * from "./Provid.vue?vue&type=script&lang=js"
import style0 from "./Provid.vue?vue&type=style&index=0&id=2c07b6fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c07b6fa",
  null
  
)

export default component.exports